// ============================================================
//  EVENIMENTE — FESTIVAL RADAR (baza de date evenimente)
//  Statusul se calculeaza AUTOMAT din start_date / end_date:
//  "live" (in desfasurare) · "upcoming" (peste X zile) · "ended"
//  ev.tba = true forteaza statusul "date in curs de confirmare".
//  Ordinea afisarii este controlata de campul "weight" (mic = sus).
//  Editeaza datele aici sau cere-mi sa actualizez.
//  Ultima verificare a calendarului: 11.09.2026.
// ============================================================

export const EVENTS = [
  {
    id: "trofeul-rasnov",
    name: "Trofeul Râșnov 2026 — Viteză în Coastă",
    slug: "trofeul-rasnov",
    start_date: "2026-09-11",
    end_date: "2026-09-13",
    location_ro: "Râșnov · Valea Cetății", location_en: "Râșnov · Valea Cetății",
    location_it: "Râșnov · Valea Cetății", location_de: "Râșnov · Valea Cetății",
    category: "sport",
    desc_ro: "Peste 100 de concurenți, mașini de competiție, prototipuri și modele istorice — trei zile de motorsport pe unul dintre traseele clasice de viteză în coastă ale României. Etapa poate fi decisivă pentru titlul național 2026. Practic la tine acasă.",
    desc_en: "Over 100 drivers, racing cars, prototypes and historic models — three days of motorsport on one of Romania's classic hillclimb tracks. The round could decide the 2026 national title. Practically on your doorstep.",
    desc_it: "Oltre 100 concorrenti, auto da corsa, prototipi e modelli storici — tre giorni di motorsport su uno dei tracciati classici di cronoscalata della Romania. La tappa può essere decisiva per il titolo nazionale 2026. Praticamente a casa tua.",
    desc_de: "Über 100 Teilnehmer, Rennwagen, Prototypen und historische Modelle — drei Tage Motorsport auf einem der klassischen Bergrennen-Kurse Rumäniens. Der Lauf kann über den nationalen Titel 2026 entscheiden. Praktisch vor der Haustür.",
    official_url: "https://fras.ro",
    image: "/assets/event-trofeul-rasnov.jpg",
    distance_ro: "în Râșnov", distance_en: "in Râșnov", distance_it: "a Râșnov", distance_de: "in Râșnov",
    featured: true,
    booking_campaign: true,
    campaign_ro: "Motoarele se aud în Râșnov. Tu dormi câteva străzi mai încolo. — Trofeul Râșnov aduce adrenalina pe Valea Cetății. După ultima manșă: grădină, duș, liniște și un pat king-size.",
    campaign_en: "You can hear the engines in Râșnov. You sleep a few streets away. — Trofeul Râșnov brings the adrenaline to Valea Cetății. After the last run: garden, shower, silence and a king-size bed.",
    campaign_it: "I motori si sentono a Râșnov. Tu dormi a poche strade di distanza. — Il Trofeul Râșnov porta l'adrenalina in Valea Cetății. Dopo l'ultima manche: giardino, doccia, silenzio e un letto king-size.",
    campaign_de: "Die Motoren sind in Râșnov zu hören. Du schläfst ein paar Straßen weiter. — Das Trofeul Râșnov bringt Adrenalin ins Valea Cetății. Nach dem letzten Lauf: Garten, Dusche, Ruhe und ein King-Size-Bett.",
    last_verified: "2026-09-11",
    source_name: "FRAS", source_url: "https://fras.ro",
    weight: 1,
  },
  {
    id: "street-delivery",
    name: "Street Delivery Brașov #6 — „Ce rămâne?”",
    slug: "street-delivery-brasov",
    start_date: "2026-09-11",
    end_date: "2026-09-13",
    location_ro: "Brașov · Curtea Corpului N, Universitatea Transilvania",
    location_en: "Brașov · Building N courtyard, Transilvania University",
    location_it: "Brașov · Cortile del Corpo N, Università Transilvania",
    location_de: "Brașov · Hof des Gebäudes N, Universität Transilvania",
    category: "art",
    desc_ro: "Artă, film, lectură, poezie, performance, ateliere, natură și comunitate. Atenție: din cauza unei modificări de ultim moment, activitățile sunt concentrate în curtea Corpului N al Universității Transilvania — nu pe tronsonul Star–Modarom, cum fusese anunțat inițial.",
    desc_en: "Art, film, reading, poetry, performance, workshops, nature and community. Note: due to a last-minute change, activities are concentrated in the courtyard of Building N of Transilvania University — not on the Star–Modarom stretch, as initially announced.",
    desc_it: "Arte, film, lettura, poesia, performance, laboratori, natura e comunità. Attenzione: per una modifica dell'ultimo momento, le attività sono concentrate nel cortile del Corpo N dell'Università Transilvania — non sul tratto Star–Modarom, come annunciato inizialmente.",
    desc_de: "Kunst, Film, Lesungen, Poesie, Performance, Workshops, Natur und Gemeinschaft. Achtung: Wegen einer kurzfristigen Änderung finden die Aktivitäten im Hof des Gebäudes N der Universität Transilvania statt — nicht auf dem Abschnitt Star–Modarom, wie ursprünglich angekündigt.",
    official_url: "https://streetdelivery.ro",
    image: "/assets/event-street-delivery.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "Orașul iese din clădiri. — Trei zile de artă, oameni, idei și conversații în Brașov. Seara te întorci la liniștea din Râșnov.",
    campaign_en: "The city steps out of its buildings. — Three days of art, people, ideas and conversations in Brașov. In the evening you return to the quiet of Râșnov.",
    campaign_it: "La città esce dagli edifici. — Tre giorni di arte, persone, idee e conversazioni a Brașov. La sera torni nella quiete di Râșnov.",
    campaign_de: "Die Stadt tritt aus ihren Gebäuden. — Drei Tage Kunst, Menschen, Ideen und Gespräche in Brașov. Abends kehrst du in die Stille von Râșnov zurück.",
    last_verified: "2026-09-11",
    source_name: "BizBrasov.ro", source_url: null,
    weight: 2,
  },
  {
    id: "dramatic",
    name: "DrAMAtic — Festivalul Internațional de Teatru Brașov",
    slug: "dramatic-brasov",
    start_date: "2026-09-11",
    end_date: "2026-09-20",
    location_ro: "Brașov · Teatrul Sică Alexandrescu",
    location_en: "Brașov · Sică Alexandrescu Theatre",
    location_it: "Brașov · Teatro Sică Alexandrescu",
    location_de: "Brașov · Theater Sică Alexandrescu",
    category: "theatre",
    desc_ro: "Zece zile de teatru, muzică, performance și întâlniri, cu peste 200 de artiști și producții din România, Grecia, Ungaria și Republica Moldova. Programul include inclusiv Marcel Iureș și evenimente de teatru muzical.",
    desc_en: "Ten days of theatre, music, performance and encounters, with over 200 artists and productions from Romania, Greece, Hungary and the Republic of Moldova. The programme includes Marcel Iureș and musical theatre events.",
    desc_it: "Dieci giorni di teatro, musica, performance e incontri, con oltre 200 artisti e produzioni da Romania, Grecia, Ungheria e Moldavia. Il programma include anche Marcel Iureș ed eventi di teatro musicale.",
    desc_de: "Zehn Tage Theater, Musik, Performance und Begegnungen mit über 200 Künstlern und Produktionen aus Rumänien, Griechenland, Ungarn und der Republik Moldau. Im Programm unter anderem Marcel Iureș und Musiktheater.",
    official_url: "https://teatrulsicaalexandrescu.ro",
    image: "/assets/event-dramatic.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "Transilvania nu înseamnă doar munți și castele. — Uneori înseamnă și o seară bună de teatru, urmată de o noapte liniștită în Râșnov.",
    campaign_en: "Transylvania is not only mountains and castles. — Sometimes it's also a good evening of theatre, followed by a quiet night in Râșnov.",
    campaign_it: "La Transilvania non è solo montagne e castelli. — A volte è anche una bella serata a teatro, seguita da una notte tranquilla a Râșnov.",
    campaign_de: "Siebenbürgen ist nicht nur Berge und Burgen. — Manchmal ist es auch ein guter Theaterabend, gefolgt von einer ruhigen Nacht in Râșnov.",
    last_verified: "2026-09-11",
    source_name: "teatrulsicaalexandrescu.ro", source_url: "https://teatrulsicaalexandrescu.ro",
    weight: 3,
  },
  {
    id: "fis-grand-prix",
    name: "FIS Ski Jumping Grand Prix — Râșnov",
    slug: "fis-grand-prix-rasnov",
    start_date: "2026-09-19",
    end_date: "2026-09-20",
    location_ro: "Râșnov · Trambulina Valea Cărbunării",
    location_en: "Râșnov · Valea Cărbunării Ski Jump",
    location_it: "Râșnov · Trampolino Valea Cărbunării",
    location_de: "Râșnov · Schanze Valea Cărbunării",
    category: "sport",
    desc_ro: "Calendarul oficial FIS confirmă pentru 19–20 septembrie competiții masculine și feminine de Grand Prix la Râșnov. Unul dintre cele mai puternice evenimente sportive ale toamnei — la câteva minute de casă.",
    desc_en: "The official FIS calendar confirms men's and women's Grand Prix competitions in Râșnov on 19–20 September. One of the strongest sporting events of the autumn — minutes from the house.",
    desc_it: "Il calendario ufficiale FIS conferma per il 19–20 settembre le gare di Grand Prix maschili e femminili a Râșnov. Uno degli eventi sportivi più forti dell'autunno — a pochi minuti da casa.",
    desc_de: "Der offizielle FIS-Kalender bestätigt für den 19.–20. September Grand-Prix-Wettbewerbe der Männer und Frauen in Râșnov. Eines der stärksten Sportereignisse des Herbstes — nur wenige Minuten vom Haus.",
    official_url: "https://www.fis-ski.com",
    image: "/assets/event-fis-grand-prix.jpg",
    page: "/eveniment/fis-grand-prix-rasnov",
    distance_ro: "în Râșnov", distance_en: "in Râșnov", distance_it: "a Râșnov", distance_de: "in Râșnov",
    featured: true,
    booking_campaign: true,
    campaign_ro: "EI ZBOARĂ. TU DORMI LA IMPERFECT HOUSE. — Pe 19–20 septembrie, cei mai buni săritori cu schiurile vin la Râșnov. Ziua — zboruri de pe trambulină. Seara — foc în grădină. Dimineața — cafea și încă o zi de competiție.",
    campaign_en: "THEY FLY. YOU SLEEP AT IMPERFECT HOUSE. — On 19–20 September, the world's best ski jumpers come to Râșnov. Daytime — flights off the jump. Evening — fire in the garden. Morning — coffee and another day of competition.",
    campaign_it: "LORO VOLANO. TU DORMI A IMPERFECT HOUSE. — Il 19–20 settembre i migliori saltatori con gli sci arrivano a Râșnov. Di giorno — voli dal trampolino. Di sera — fuoco in giardino. Al mattino — caffè e un altro giorno di gare.",
    campaign_de: "SIE FLIEGEN. DU SCHLÄFST IM IMPERFECT HOUSE. — Am 19.–20. September kommen die besten Skispringer nach Râșnov. Tagsüber — Flüge von der Schanze. Abends — Feuer im Garten. Morgens — Kaffee und noch ein Wettkampftag.",
    last_verified: "2026-09-11",
    source_name: "fis-ski.com", source_url: "https://www.fis-ski.com",
    weight: 4,
  },
  {
    id: "alpin-film",
    name: "Alpin Film Festival 2026",
    slug: "alpin-film-festival",
    start_date: "2026-09-21",
    end_date: "2026-09-27",
    location_ro: "Brașov · Râșnov · Bușteni", location_en: "Brașov · Râșnov · Bușteni",
    location_it: "Brașov · Râșnov · Bușteni", location_de: "Brașov · Râșnov · Bușteni",
    category: "film",
    desc_ro: "Unul dintre cele mai potrivite evenimente pentru profilul Imperfect House: peste 40 de documentare montane din peste 18 țări, cu proiecții inclusiv la Cinema Amza Pellea din Râșnov. Selecția românească include și un film despre siguranța pe Via Transilvanica.",
    desc_en: "One of the best-matched events for the Imperfect House spirit: over 40 mountain documentaries from more than 18 countries, with screenings also at Cinema Amza Pellea in Râșnov. The Romanian selection includes a film about safety on Via Transilvanica.",
    desc_it: "Uno degli eventi più adatti allo spirito di Imperfect House: oltre 40 documentari di montagna da più di 18 paesi, con proiezioni anche al Cinema Amza Pellea di Râșnov. La selezione rumena include anche un film sulla sicurezza sulla Via Transilvanica.",
    desc_de: "Eines der passendsten Events für das Imperfect House: über 40 Bergdokumentationen aus mehr als 18 Ländern, mit Vorführungen auch im Kino Amza Pellea in Râșnov. Die rumänische Auswahl umfasst auch einen Film über Sicherheit auf der Via Transilvanica.",
    official_url: "https://alpinfilmfestival.ro",
    image: "/assets/event-alpin-film.jpg",
    page: "/eveniment/alpin-film-festival",
    distance_ro: "în zonă", distance_en: "in the area", distance_it: "in zona", distance_de: "in der Region",
    featured: false,
    booking_campaign: true,
    campaign_ro: "MUNTELE AJUNGE PE ECRAN. ȘI ECRANUL AJUNGE ÎN RÂȘNOV. — Filme din peste 18 țări, povești de alpinism, natură și aventură. Vezi filmul. Dormi la Imperfect. Dimineața ieși și vezi muntele adevărat.",
    campaign_en: "THE MOUNTAIN REACHES THE SCREEN. AND THE SCREEN REACHES RÂȘNOV. — Films from over 18 countries, stories of alpinism, nature and adventure. Watch the film. Sleep at Imperfect. In the morning, step out and see the real mountain.",
    campaign_it: "LA MONTAGNA ARRIVA SULLO SCHERMO. E LO SCHERMO ARRIVA A RÂȘNOV. — Film da oltre 18 paesi, storie di alpinismo, natura e avventura. Guarda il film. Dormi a Imperfect. Al mattino esci e vedi la montagna vera.",
    campaign_de: "DER BERG KOMMT AUFS LEINWAND. UND DIE LEINWAND KOMMT NACH RÂȘNOV. — Filme aus über 18 Ländern, Geschichten von Alpinismus, Natur und Abenteuer. Schau den Film. Schlaf im Imperfect. Morgens gehst du raus und siehst den echten Berg.",
    last_verified: "2026-09-11",
    source_name: "Revista Film", source_url: null,
    weight: 5,
  },
  {
    id: "transilvania-blues",
    name: "Transilvania Blues Festival — ediția VIII",
    slug: "transilvania-blues-festival",
    start_date: "2026-09-25",
    end_date: "2026-09-27",
    location_ro: "Brașov · Bastionul Artiștilor",
    location_en: "Brașov · Bastionul Artiștilor",
    location_it: "Brașov · Bastionul Artiștilor",
    location_de: "Brașov · Bastionul Artiștilor",
    category: "music",
    desc_ro: "Trei zile de blues, inclusiv artiști internaționali, într-un spațiu emblematic al Brașovului. Ediția 2026 se mută outdoor, la Bastionul Țesătorilor / Bastionul Artiștilor.",
    desc_en: "Three days of blues, including international artists, in one of Brașov's landmark venues. The 2026 edition moves outdoors, to Bastionul Țesătorilor / Bastionul Artiștilor.",
    desc_it: "Tre giorni di blues, anche con artisti internazionali, in uno spazio emblematico di Brașov. L'edizione 2026 si sposta all'aperto, al Bastionul Țesătorilor / Bastionul Artiștilor.",
    desc_de: "Drei Tage Blues, auch mit internationalen Künstlern, an einem Wahrzeichen von Brașov. Die Ausgabe 2026 zieht ins Freie, zum Bastionul Țesătorilor / Bastionul Artiștilor.",
    official_url: "https://www.iabilet.ro",
    image: "/assets/event-transilvania-blues.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "Mountains by day. Blues by night. — Brașovul cântă. Râșnovul te lasă să dormi.",
    campaign_en: "Mountains by day. Blues by night. — Brașov sings. Râșnov lets you sleep.",
    campaign_it: "Mountains by day. Blues by night. — Brașov canta. Râșnov ti lascia dormire.",
    campaign_de: "Mountains by day. Blues by night. — Brașov singt. Râșnov lässt dich schlafen.",
    last_verified: "2026-09-11",
    source_name: "iabilet.ro", source_url: "https://www.iabilet.ro",
    weight: 6,
  },
  {
    id: "maraton-piatra-craiului",
    name: "Maraton Piatra Craiului",
    slug: "maraton-piatra-craiului",
    start_date: "2026-09-26",
    end_date: "2026-09-27",
    location_ro: "Zărnești", location_en: "Zărnești", location_it: "Zărnești", location_de: "Zărnești",
    category: "sport",
    desc_ro: "Una dintre competițiile istorice de alergare montană din România: traseul principal are 39,7 km și ±2.250 m diferență de nivel, iar duminică există și MPC Junior pentru copii.",
    desc_en: "One of Romania's historic mountain running races: the main course is 39.7 km with ±2,250 m of elevation, and on Sunday there is also MPC Junior for kids.",
    desc_it: "Una delle storiche gare di corsa in montagna della Romania: il percorso principale misura 39,7 km con ±2.250 m di dislivello, e la domenica c'è anche la MPC Junior per i bambini.",
    desc_de: "Einer der historischen Bergläufe Rumäniens: Die Hauptstrecke ist 39,7 km lang mit ±2.250 m Höhendifferenz, und am Sonntag gibt es auch den MPC Junior für Kinder.",
    official_url: "https://maratonpiatracraiului.ro",
    image: "/assets/event-maraton-piatra-craiului.jpg",
    page: "/eveniment/maraton-piatra-craiului",
    distance_ro: "15 km · aprox. 20 min", distance_en: "15 km · approx. 20 min", distance_it: "15 km · ca. 20 min", distance_de: "15 km · ca. 20 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "39,7 km prin Piatra Craiului. — După asta, patul de 180×200 de la Imperfect House nu mai este facilitate. Este premiu.",
    campaign_en: "39.7 km through Piatra Craiului. — After that, the 180×200 bed at Imperfect House is no longer an amenity. It's the prize.",
    campaign_it: "39,7 km attraverso il Piatra Craiului. — Dopo, il letto 180×200 di Imperfect House non è più un comfort. È il premio.",
    campaign_de: "39,7 km durch den Piatra Craiului. — Danach ist das 180×200-Bett im Imperfect House keine Annehmlichkeit mehr. Es ist der Preis.",
    last_verified: "2026-09-11",
    source_name: "maratonpiatracraiului.ro", source_url: "https://maratonpiatracraiului.ro",
    weight: 7,
  },
  {
    id: "brasov-running",
    name: "Brașov Running Festival",
    slug: "brasov-running-festival",
    start_date: "2026-10-03",
    end_date: "2026-10-04",
    location_ro: "Brașov", location_en: "Brașov", location_it: "Brașov", location_de: "Brașov",
    category: "sport",
    desc_ro: "Eveniment internațional de alergare: tRUNsylvania International 10K — competiție World Athletics Elite Label — plus curse pentru amatori, copii, trail-to-road și Fun Run. Accesul spectatorilor este gratuit.",
    desc_en: "An international running event: tRUNsylvania International 10K — a World Athletics Elite Label race — plus amateur, kids, trail-to-road and Fun Run races. Spectator access is free.",
    desc_it: "Un evento internazionale di corsa: tRUNsylvania International 10K — gara World Athletics Elite Label — più corse per amatori, bambini, trail-to-road e Fun Run. L'accesso per gli spettatori è gratuito.",
    desc_de: "Ein internationaler Laufevent: tRUNsylvania International 10K — ein World-Athletics-Elite-Label-Rennen — plus Läufe für Amateure, Kinder, Trail-to-Road und Fun Run. Der Zutritt für Zuschauer ist kostenlos.",
    official_url: "https://brasovrun.ro",
    image: "/assets/event-brasov-running.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "Run Brașov. Sleep Râșnov. — Aleargă 3, 5 sau 10 kilometri. Noi nu verificăm timpul. Doar dacă ai rezervare.",
    campaign_en: "Run Brașov. Sleep Râșnov. — Run 3, 5 or 10 kilometres. We don't check your time. Only your booking.",
    campaign_it: "Run Brașov. Sleep Râșnov. — Corri 3, 5 o 10 chilometri. Non controlliamo il tempo. Solo la prenotazione.",
    campaign_de: "Run Brașov. Sleep Râșnov. — Lauf 3, 5 oder 10 Kilometer. Wir prüfen nicht deine Zeit. Nur deine Buchung.",
    last_verified: "2026-09-11",
    source_name: "brasovrun.ro", source_url: "https://brasovrun.ro",
    weight: 8,
  },
  {
    id: "dracula-film",
    name: "Dracula Film Festival",
    slug: "dracula-film-festival",
    start_date: "2026-10-08",
    end_date: "2026-10-11",
    location_ro: "Brașov", location_en: "Brașov", location_it: "Brașov", location_de: "Brașov",
    category: "film",
    desc_ro: "Ediția XIV, dedicată horror, fantasy, SF, thriller și supranatural — festivalul care transformă Brașovul în capitala genului, la jumătate de oră de Castelul Bran.",
    desc_en: "The XIV edition dedicated to horror, fantasy, sci-fi, thriller and the supernatural — the festival that turns Brașov into the genre's capital, half an hour from Bran Castle.",
    desc_it: "La XIV edizione dedicata a horror, fantasy, fantascienza, thriller e soprannaturale — il festival che trasforma Brașov nella capitale del genere, a mezz'ora dal Castello di Bran.",
    desc_de: "Die XIV. Ausgabe, gewidmet Horror, Fantasy, Science-Fiction, Thriller und Übersinnlichem — das Festival, das Brașov zur Hauptstadt des Genres macht, eine halbe Stunde von Schloss Bran.",
    official_url: null,
    image: "/assets/event-dracula-film.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "DRACULA DUPĂ LĂSAREA SERII. — Filme horror în Brașov. Castelul Bran aproape. Pădure lângă casă. Noi stingem lumina. De acolo te descurci.",
    campaign_en: "DRACULA AFTER DARK. — Horror films in Brașov. Bran Castle nearby. Forest next to the house. We turn off the light. From there, you're on your own.",
    campaign_it: "DRACULA DOPO IL TRAMONTO. — Film horror a Brașov. Il Castello di Bran vicino. Il bosco accanto a casa. Noi spegniamo la luce. Da lì in poi te la cavi tu.",
    campaign_de: "DRACULA NACH EINBRUCH DER DUNKELHEIT. — Horrorfilme in Brașov. Schloss Bran ganz nah. Wald neben dem Haus. Wir machen das Licht aus. Ab da bist du auf dich allein gestellt.",
    last_verified: "2026-09-11",
    source_name: "BizBrasov.ro", source_url: null,
    weight: 9,
  },
  {
    id: "halloween-bran",
    name: "Halloween la Castelul Bran 2026",
    slug: "halloween-castelul-bran",
    start_date: "2026-10-24",
    end_date: "2026-11-01",
    location_ro: "Castelul Bran", location_en: "Bran Castle", location_it: "Castello di Bran", location_de: "Schloss Bran",
    category: "dark",
    desc_ro: "Castelul Bran confirmă experiențe tematice între 24 octombrie și 1 noiembrie. Pe 31 octombrie, programul culminant include tur tematic, petrecere, DJ și experiențe speciale; 1 noiembrie este orientat către familii.",
    desc_en: "Bran Castle confirms themed experiences between 24 October and 1 November. On 31 October the highlight programme includes a themed tour, party, DJ and special experiences; 1 November is family-oriented.",
    desc_it: "Il Castello di Bran conferma esperienze a tema tra il 24 ottobre e il 1 novembre. Il 31 ottobre il programma clou include tour tematico, festa, DJ ed esperienze speciali; il 1 novembre è orientato alle famiglie.",
    desc_de: "Schloss Bran bestätigt thematische Erlebnisse zwischen dem 24. Oktober und dem 1. November. Am 31. Oktober umfasst das Höhepunkt-Programm Themenführung, Party, DJ und besondere Erlebnisse; der 1. November richtet sich an Familien.",
    official_url: "https://www.bran-castle.com",
    image: "/assets/event-halloween-bran.jpg",
    page: "/eveniment/halloween-castelul-bran",
    distance_ro: "12 km · aprox. 20 min", distance_en: "12 km · approx. 20 min", distance_it: "12 km · ca. 20 min", distance_de: "12 km · ca. 20 Min.",
    featured: true,
    booking_campaign: true,
    campaign_ro: "HALLOWEEN IN TRANSYLVANIA. — Dormi la 20 de minute de castelul lui Dracula. Bran noaptea. Râșnov dimineața. Pădure, ceață și un pat king-size când povestea se termină.",
    campaign_en: "HALLOWEEN IN TRANSYLVANIA. — Sleep 20 minutes from Dracula's Castle. Bran by night. Râșnov in the morning. Forest, fog and a king-size bed when the story ends.",
    campaign_it: "HALLOWEEN IN TRANSILVANIA. — Dormi a 20 minuti dal Castello di Dracula. Bran di notte. Râșnov al mattino. Bosco, nebbia e un letto king-size quando la storia finisce.",
    campaign_de: "HALLOWEEN IN TRANSSILVANIEN. — Schlaf 20 Minuten von Draculas Schloss entfernt. Bran bei Nacht. Râșnov am Morgen. Wald, Nebel und ein King-Size-Bett, wenn die Geschichte endet.",
    last_verified: "2026-09-11",
    source_name: "Bran Castle", source_url: "https://www.bran-castle.com",
    weight: 10,
  },
  {
    id: "fantasy-con",
    name: "Dracula Fantasy Con",
    slug: "dracula-fantasy-con",
    start_date: "2026-10-30",
    end_date: "2026-11-02",
    location_ro: "Brașov · Coresi Shopping Resort",
    location_en: "Brașov · Coresi Shopping Resort",
    location_it: "Brașov · Coresi Shopping Resort",
    location_de: "Brașov · Coresi Shopping Resort",
    category: "dark",
    desc_ro: "Eveniment conectat la Dracula Film Festival, dedicat universului fantasy și pop culture. Se combină perfect într-un weekend complet: Bran + Dracula Film + Fantasy Con + Râșnov.",
    desc_en: "An event connected to Dracula Film Festival, dedicated to the fantasy and pop-culture universe. It combines perfectly into a full weekend: Bran + Dracula Film + Fantasy Con + Râșnov.",
    desc_it: "Un evento collegato al Dracula Film Festival, dedicato all'universo fantasy e pop culture. Si combina perfettamente in un weekend completo: Bran + Dracula Film + Fantasy Con + Râșnov.",
    desc_de: "Ein Event verbunden mit dem Dracula Film Festival, gewidmet dem Fantasy- und Popkultur-Universum. Perfekt kombinierbar zu einem ganzen Wochenende: Bran + Dracula Film + Fantasy Con + Râșnov.",
    official_url: null,
    image: "/assets/event-fantasy-con.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "4 zile de Dark Transylvania. — Bran + Dracula Film + Fantasy Con + Râșnov. Un weekend întreg de povești întunecate, cu somn liniștit la 20 de minute de castel.",
    campaign_en: "4 days of Dark Transylvania. — Bran + Dracula Film + Fantasy Con + Râșnov. A whole weekend of dark tales, with quiet sleep 20 minutes from the castle.",
    campaign_it: "4 giorni di Dark Transylvania. — Bran + Dracula Film + Fantasy Con + Râșnov. Un intero weekend di storie oscure, con sonno tranquillo a 20 minuti dal castello.",
    campaign_de: "4 Tage Dark Transylvania. — Bran + Dracula Film + Fantasy Con + Râșnov. Ein ganzes Wochenende dunkler Geschichten, mit ruhigem Schlaf 20 Minuten vom Schloss.",
    last_verified: "2026-09-11",
    source_name: "BizBrasov.ro", source_url: null,
    weight: 11,
  },
  {
    id: "christmas-market",
    name: "Târgul de Crăciun Brașov 2026",
    slug: "targul-de-craciun-brasov",
    start_date: "2026-11-27",
    end_date: "2027-01-03",
    tba: true,
    location_ro: "Brașov · Piața Sfatului", location_en: "Brașov · Council Square",
    location_it: "Brașov · Piazza del Consiglio", location_de: "Brașov · Rathausplatz",
    category: "winter",
    desc_ro: "Vin fiert în Piața Sfatului, zăpadă dacă avem noroc, foc și liniște când te întorci la Râșnov. Sursele indică sfârșitul lui noiembrie – începutul lui ianuarie; data finală va fi actualizată imediat după anunțul oficial al Primăriei Brașov.",
    desc_en: "Mulled wine in the Council Square, snow if we're lucky, fire and quiet when you return to Râșnov. Sources point to late November – early January; the final dates will be updated right after the City Hall's official announcement.",
    desc_it: "Vin brulé in Piazza del Consiglio, neve se siamo fortunati, fuoco e quiete quando torni a Râșnov. Le fonti indicano fine novembre – inizio gennaio; le date definitive saranno aggiornate subito dopo l'annuncio ufficiale del Comune di Brașov.",
    desc_de: "Glühwein auf dem Rathausplatz, Schnee wenn wir Glück haben, Feuer und Ruhe wenn du nach Râșnov zurückkehrst. Quellen deuten auf Ende November – Anfang Januar; die finalen Termine werden sofort nach der offiziellen Ankündigung der Stadt Brașov aktualisiert.",
    official_url: null,
    image: "/assets/event-christmas-market.jpg",
    page: "/eveniment/targul-de-craciun-brasov",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: true,
    campaign_ro: "CHRISTMAS IN TRANSYLVANIA. — Vin fiert în Piața Sfatului. Zăpadă dacă avem noroc. Foc și liniște când te întorci la Râșnov. Datele finale vor fi actualizate imediat după anunțul oficial.",
    campaign_en: "CHRISTMAS IN TRANSYLVANIA. — Mulled wine in the Council Square. Snow if we're lucky. Fire and quiet when you return to Râșnov. Final dates will be updated right after the official announcement.",
    campaign_it: "CHRISTMAS IN TRANSYLVANIA. — Vin brulé in Piazza del Consiglio. Neve se siamo fortunati. Fuoco e quiete quando torni a Râșnov. Le date definitive saranno aggiornate subito dopo l'annuncio ufficiale.",
    campaign_de: "CHRISTMAS IN TRANSYLVANIA. — Glühwein auf dem Rathausplatz. Schnee wenn wir Glück haben. Feuer und Ruhe wenn du nach Râșnov zurückkehrst. Die finalen Termine folgen sofort nach der offiziellen Ankündigung.",
    last_verified: "2026-09-11",
    source_name: "Umblu Teleleu", source_url: null,
    weight: 12,
  },
  {
    id: "fote-2027",
    name: "FOTE / EYOF Brașov 2027 — Festivalul Olimpic al Tineretului European",
    slug: "eyof-brasov-2027",
    start_date: "2027-02-14",
    end_date: "2027-02-21",
    location_ro: "Brașov · Râșnov · Predeal · Azuga · Fundata",
    location_en: "Brașov · Râșnov · Predeal · Azuga · Fundata",
    location_it: "Brașov · Râșnov · Predeal · Azuga · Fundata",
    location_de: "Brașov · Râșnov · Predeal · Azuga · Fundata",
    category: "sport",
    desc_ro: "Confirmat de COSR și Comitetul Olimpic European pentru 14–21 februarie 2027. Râșnov este localitate-gazdă oficială — baza de sărituri cu schiurile din Valea Cărbunării este pregătită pentru probele FOTE. Schi, snowboard, biatlon, patinaj, hochei, sărituri cu schiurile.",
    desc_en: "Confirmed by the Romanian Olympic Committee and the European Olympic Committees for 14–21 February 2027. Râșnov is an official host city — the Valea Cărbunării ski-jumping base is being prepared for the EYOF events. Skiing, snowboarding, biathlon, skating, hockey, ski jumping.",
    desc_it: "Confermato dal COSR e dai Comitati Olimpici Europei per il 14–21 febbraio 2027. Râșnov è città ospitante ufficiale — la base di salto con gli sci di Valea Cărbunării è in preparazione per le gare EYOF. Sci, snowboard, biathlon, pattinaggio, hockey, salto con gli sci.",
    desc_de: "Vom Rumänischen Olympischen Komitee und den Europäischen Olympischen Komitees für den 14.–21. Februar 2027 bestätigt. Râșnov ist offizieller Austragungsort — die Skisprunganlage Valea Cărbunării wird für die EYOF-Wettkämpfe vorbereitet. Ski, Snowboard, Biathlon, Eislauf, Hockey, Skispringen.",
    official_url: null,
    image: "/assets/event-fote-2027.jpg",
    page: "/fote-2027",
    distance_ro: "probe și în Râșnov", distance_en: "events also in Râșnov", distance_it: "gare anche a Râșnov", distance_de: "Wettkämpfe auch in Râșnov",
    featured: true,
    booking_campaign: true,
    campaign_always: true,
    campaign_ro: "EUROPE COMES TO RÂȘNOV. — Sportivi tineri din toată Europa. Schi. Snowboard. Biatlon. Patinaj. Hochei. Sărituri cu schiurile. Și o parte din competiție chiar aici, în Râșnov. Stay close to the action. Sleep away from the noise. Pre-rezervările sunt deschise.",
    campaign_en: "EUROPE COMES TO RÂȘNOV. — Young athletes from all over Europe. Skiing. Snowboarding. Biathlon. Skating. Hockey. Ski jumping. And part of the competition right here, in Râșnov. Stay close to the action. Sleep away from the noise. Pre-bookings are open.",
    campaign_it: "EUROPE COMES TO RÂȘNOV. — Giovani atleti da tutta Europa. Sci. Snowboard. Biathlon. Pattinaggio. Hockey. Salto con gli sci. E parte della competizione proprio qui, a Râșnov. Stay close to the action. Sleep away from the noise. Le pre-prenotazioni sono aperte.",
    campaign_de: "EUROPE COMES TO RÂȘNOV. — Junge Athleten aus ganz Europa. Ski. Snowboard. Biathlon. Eislauf. Hockey. Skispringen. Und ein Teil der Wettkämpfe genau hier, in Râșnov. Stay close to the action. Sleep away from the noise. Vorreservierungen sind offen.",
    last_verified: "2026-09-11",
    source_name: "COSR / EOC", source_url: "https://cosr.ro",
    weight: 13,
  },
  // ---------- Ediții încheiate 2026 (păstrate pentru SEO și edițiile 2027) ----------
  {
    id: "ffir",
    name: "Festivalul de Film și Istorii Râșnov (FFIR)",
    slug: "ffir",
    start_date: "2026-08-07",
    end_date: "2026-08-23",
    location_ro: "Râșnov (+ Brașov, Codlea, Feldioara)",
    location_en: "Râșnov (+ Brașov, Codlea, Feldioara)",
    location_it: "Râșnov (+ Brașov, Codlea, Feldioara)",
    location_de: "Râșnov (+ Brașov, Codlea, Feldioara)",
    category: "film",
    desc_ro: "Ediția 2026 s-a încheiat: 17 zile cu filme, dezbateri, concerte, teatru, cărți și expoziții — chiar aici, în Râșnov. Următoarea ediție: vara 2027.",
    desc_en: "The 2026 edition has ended: 17 days of films, debates, concerts, theatre, books and exhibitions — right here in Râșnov. Next edition: summer 2027.",
    desc_it: "L'edizione 2026 è finita: 17 giorni di film, dibattiti, concerti, teatro, libri e mostre — proprio qui, a Râșnov. Prossima edizione: estate 2027.",
    desc_de: "Die Ausgabe 2026 ist vorbei: 17 Tage mit Filmen, Debatten, Konzerten, Theater, Büchern und Ausstellungen — genau hier in Râșnov. Nächste Ausgabe: Sommer 2027.",
    official_url: "https://ffir.ro",
    image: null,
    distance_ro: "în Râșnov", distance_en: "in Râșnov", distance_it: "a Râșnov", distance_de: "in Râșnov",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "ffir.ro", source_url: "https://ffir.ro",
    weight: 90,
  },
  {
    id: "jazz-blues",
    name: "Brașov Jazz & Blues Festival",
    slug: "brasov-jazz-blues",
    start_date: "2026-08-14",
    end_date: "2026-08-16",
    location_ro: "Brașov", location_en: "Brașov", location_it: "Brașov", location_de: "Brașov",
    category: "music",
    desc_ro: "Ediția 2026 s-a încheiat. Mountains by day. Blues by night. Următoarea ediție: vara 2027 — actualizăm când apar datele.",
    desc_en: "The 2026 edition has ended. Mountains by day. Blues by night. Next edition: summer 2027 — we update when dates are out.",
    desc_it: "L'edizione 2026 è finita. Mountains by day. Blues by night. Prossima edizione: estate 2027 — aggiorniamo quando escono le date.",
    desc_de: "Die Ausgabe 2026 ist vorbei. Mountains by day. Blues by night. Nächste Ausgabe: Sommer 2027 — wir aktualisieren, sobald die Termine feststehen.",
    official_url: "https://brasovjazz.ro",
    image: null,
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "Brașov Jazz & Blues Festival", source_url: "https://brasovjazz.ro",
    weight: 91,
  },
  {
    id: "oktoberfest",
    name: "Oktoberfest Brașov 2026",
    slug: "oktoberfest-brasov",
    start_date: "2026-08-27",
    end_date: "2026-09-06",
    location_ro: "Brașov · zona Tractorul / Str. Turnului",
    location_en: "Brașov · Tractorul area / Turnului St.",
    location_it: "Brașov · zona Tractorul / Via Turnului",
    location_de: "Brașov · Bereich Tractorul / Turnului-Str.",
    category: "beer",
    desc_ro: "Ediția 2026 (27 august – 6 septembrie) s-a încheiat: 11 zile de bere, muzică live, formații germane, parada Oktoberfest, bratwurst și costume bavareze. Următoarea ediție: toamna 2027 — actualizăm imediat ce apar datele oficiale.",
    desc_en: "The 2026 edition (27 August – 6 September) has ended: 11 days of beer, live music, German bands, the Oktoberfest parade, bratwurst and Bavarian costumes. Next edition: autumn 2027 — we update as soon as official dates are out.",
    desc_it: "L'edizione 2026 (27 agosto – 6 settembre) è finita: 11 giorni di birra, musica dal vivo, band tedesche, la parata dell'Oktoberfest, bratwurst e costumi bavaresi. Prossima edizione: autunno 2027 — aggiorniamo appena escono le date ufficiali.",
    desc_de: "Die Ausgabe 2026 (27. August – 6. September) ist vorbei: 11 Tage Bier, Livemusik, deutsche Bands, der Oktoberfest-Umzug, Bratwurst und bayerische Trachten. Nächste Ausgabe: Herbst 2027 — wir aktualisieren, sobald die offiziellen Termine feststehen.",
    official_url: "https://oktoberfestromania.ro",
    image: "/assets/oktoberfest-2026.jpg",
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: false,
    campaign_ro: "Feiern in Kronstadt. Schlafen in Rosenau. — Ediția 2027 vine în toamnă. Pre-rezervările se deschid când apar datele oficiale.",
    campaign_en: "Feiern in Kronstadt. Schlafen in Rosenau. — The 2027 edition comes in autumn. Pre-bookings open when official dates are out.",
    campaign_it: "Feiern in Kronstadt. Schlafen in Rosenau. — L'edizione 2027 arriva in autunno. Le pre-prenotazioni si aprono quando escono le date ufficiali.",
    campaign_de: "Feiern in Kronstadt. Schlafen in Rosenau. — Die Ausgabe 2027 kommt im Herbst. Vorreservierungen öffnen, sobald die offiziellen Termine feststehen.",
    last_verified: "2026-09-11",
    source_name: "Oktoberfest Romania", source_url: "https://oktoberfestromania.ro",
    weight: 92,
  },
  {
    id: "massif",
    name: "MASSIF",
    slug: "massif",
    start_date: "2026-03-02",
    end_date: "2026-03-07",
    location_ro: "Poiana Brașov", location_en: "Poiana Brașov", location_it: "Poiana Brașov", location_de: "Poiana Brașov",
    category: "winter",
    desc_ro: "Ediția 2026 s-a încheiat. Massif Week Takeovers: muzică, munte și après-ski în Poiana Brașov. Actualizăm când apar datele următoarei ediții.",
    desc_en: "The 2026 edition has ended. Massif Week Takeovers: music, mountains and après-ski in Poiana Brașov. We update when the next edition's dates are out.",
    desc_it: "L'edizione 2026 è finita. Massif Week Takeovers: musica, montagna e après-ski a Poiana Brașov. Aggiorniamo quando escono le date della prossima edizione.",
    desc_de: "Die Ausgabe 2026 ist vorbei. Massif Week Takeovers: Musik, Berge und Après-Ski in Poiana Brașov. Wir aktualisieren, sobald die Termine der nächsten Ausgabe feststehen.",
    official_url: "https://bemassif.com",
    image: null,
    distance_ro: "15 km · aprox. 25 min", distance_en: "15 km · approx. 25 min", distance_it: "15 km · ca. 25 min", distance_de: "15 km · ca. 25 Min.",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "bemassif.com", source_url: "https://bemassif.com",
    weight: 93,
  },
  {
    id: "sonoro",
    name: "SoNoRo Musikland",
    slug: "sonoro-musikland",
    start_date: "2026-07-17",
    end_date: "2026-07-27",
    location_ro: "Transilvania (Meșendorf, Criț, Viscri, Poiana Brașov)",
    location_en: "Transylvania (Meșendorf, Criț, Viscri, Poiana Brașov)",
    location_it: "Transilvania (Meșendorf, Criț, Viscri, Poiana Brașov)",
    location_de: "Siebenbürgen (Meșendorf, Criț, Viscri, Poiana Brașov)",
    category: "classical",
    desc_ro: "Ediția 2026 s-a încheiat. Muzică de cameră și patrimoniu transilvănean — festivalul pentru călătorii lenti și culturali. Următoarea ediție: 2027.",
    desc_en: "The 2026 edition has ended. Chamber music and Transylvanian heritage — the festival for slow, cultural travellers. Next edition: 2027.",
    desc_it: "L'edizione 2026 è finita. Musica da camera e patrimonio transilvano — il festival per viaggiatori lenti e culturali. Prossima edizione: 2027.",
    desc_de: "Die Ausgabe 2026 ist vorbei. Kammermusik und siebenbürgisches Kulturerbe — das Festival für langsame, kulturelle Reisende. Nächste Ausgabe: 2027.",
    official_url: "https://sonoro.ro",
    image: null,
    distance_ro: "în zonă", distance_en: "in the area", distance_it: "in zona", distance_de: "in der Region",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "Sonoro MusikLand", source_url: "https://sonoro.ro",
    weight: 94,
  },
  {
    id: "rockstadt",
    name: "Rockstadt Extreme Fest",
    slug: "rockstadt-extreme-fest",
    start_date: "2026-07-27",
    end_date: "2026-08-01",
    location_ro: "Râșnov", location_en: "Râșnov", location_it: "Râșnov", location_de: "Râșnov",
    category: "metal",
    desc_ro: "Festivalul de metal de la poalele cetății. Ediția 2026 s-a încheiat — ne vedem în 2027. Deschidem pre-rezervări când apar datele.",
    desc_en: "The metal festival at the foot of the fortress. The 2026 edition has ended — see you in 2027. We open pre-bookings when dates are announced.",
    desc_it: "Il festival metal ai piedi della fortezza. L'edizione 2026 è finita — ci vediamo nel 2027. Apriamo le prenotazioni quando escono le date.",
    desc_de: "Das Metal-Festival am Fuße der Burg. Die Ausgabe 2026 ist vorbei — wir sehen uns 2027. Vorreservierungen öffnen wir, sobald die Termine feststehen.",
    official_url: "https://rockstadtextremefest.ro",
    image: null,
    distance_ro: "în Râșnov", distance_en: "in Râșnov", distance_it: "a Râșnov", distance_de: "in Râșnov",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "ROCKSTADT EXTREME FEST", source_url: "https://rockstadtextremefest.ro",
    weight: 95,
  },
  {
    id: "junii",
    name: "Zilele Brașovului & Junii",
    slug: "zilele-brasovului",
    start_date: "2026-04-17",
    end_date: "2026-04-19",
    location_ro: "Brașov", location_en: "Brașov", location_it: "Brașov", location_de: "Brașov",
    category: "tradition",
    desc_ro: "Ediția 2026 s-a încheiat: coborârea Junilor în Cetate și petrecerea de la Pietrele lui Solomon. Nu e spectacol făcut pentru turiști — e o tradiție vie. Ne vedem în primăvara 2027.",
    desc_en: "The 2026 edition has ended: the Junii descending into the Citadel and the traditional party at Pietrele lui Solomon. Not a show made for tourists — a living tradition. See you in spring 2027.",
    desc_it: "L'edizione 2026 è finita: la discesa dei Junii nella Cittadella e la festa tradizionale alle Pietrele lui Solomon. Non uno spettacolo per turisti — una tradizione viva. Ci vediamo nella primavera 2027.",
    desc_de: "Die Ausgabe 2026 ist vorbei: der Abstieg der Junii in die Zitadelle und das traditionelle Fest bei Salomons Felsen. Keine Show für Touristen — eine lebendige Tradition. Wir sehen uns im Frühjahr 2027.",
    official_url: null,
    image: null,
    distance_ro: "17 km · aprox. 25 min", distance_en: "17 km · approx. 25 min", distance_it: "17 km · ca. 25 min", distance_de: "17 km · ca. 25 Min.",
    featured: false,
    booking_campaign: false,
    last_verified: "2026-09-11",
    source_name: "AGERPRES", source_url: null,
    weight: 96,
  },
];

// ---------- helperi (nu edita) ----------
const DAY = 86400000;

export const eventStatus = (ev, now = new Date()) => {
  if (ev.tba) return { key: "tba", days: 0 };
  const start = new Date(ev.start_date + "T00:00:00");
  const end = new Date(ev.end_date + "T23:59:59");
  if (now >= start && now <= end) return { key: "live", days: 0 };
  if (now < start) return { key: "upcoming", days: Math.ceil((start - now) / DAY) };
  return { key: "ended", days: 0 };
};

// Ordinea este controlata editorial prin campul "weight" (mic = sus).
export const sortedEvents = (now = new Date()) =>
  [...EVENTS].filter((e) => e.active !== false).sort((a, b) => (a.weight ?? 50) - (b.weight ?? 50));

// Campania activa pentru popup (primul eveniment booking_campaign CU IMAGINE care e live sau incepe in < 30 zile)
export const activeCampaign = (now = new Date()) => {
  const eligible = (ev, withImage) => {
    if (!ev.booking_campaign) return false;
    if (withImage && !ev.image) return false;
    const st = eventStatus(ev, now);
    return st.key === "live" || (st.key === "upcoming" && (st.days <= 30 || ev.campaign_always));
  };
  const events = sortedEvents(now);
  for (const ev of events) {
    if (eligible(ev, true)) return { event: ev, status: eventStatus(ev, now) };
  }
  for (const ev of events) {
    if (eligible(ev, false)) return { event: ev, status: eventStatus(ev, now) };
  }
  return null;
};
